import { useContext } from "react"
import PropTypes from "prop-types"
import { ERROR } from "helpers/data-statuses"
import Error from "components/error"
import { MetricsTemplateShape } from "components/custom-metrics-selector/helpers/prop-types"
import { combineTanStackStatuses } from "helpers/data-statuses"
import { FORECAST } from "helpers/shapes/simulator"
import { useModelBetaFields } from "resources/beta"
import AssetViewCustomComponent from "./component"
import MetricsSelectorWrapper from "./metrics-selector"

export default function AssetViewCustom({ modelMetadata, templateMetadata, context, instrumentsWithMetadata, availableMetrics, flattenedMetrics, betaInstrument, selectedMetrics, setSelectedMetrics, customSelectedMetrics, forecasts, ...props }) {
  const { modelId } = useContext(context)
  const [modelBetaFields, modelBetaFieldsStatus] = useModelBetaFields(modelId)
  const status = combineTanStackStatuses([modelBetaFieldsStatus])

  if (status === ERROR) {
    return <Error />
  }

  return <>
    <MetricsSelectorWrapper
      context={context}
      modelMetadata={modelMetadata}
      selectedMetrics={selectedMetrics}
      templateMetadata={templateMetadata}
      setSelectedMetrics={setSelectedMetrics}
      availableMetrics={availableMetrics}
      flattenedMetrics={flattenedMetrics}
    />
    <AssetViewCustomComponent
      context={context}
      betaFields={modelBetaFields}
      betaInstrument={betaInstrument}
      forecasts={forecasts}
      templateMetadata={templateMetadata}
      instrumentsWithMetadata={instrumentsWithMetadata}
      selectedMetrics={selectedMetrics}
      customSelectedMetrics={customSelectedMetrics}
      {...props}
    />
  </>
}

AssetViewCustom.propTypes = {
  modelMetadata: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired,
  templateMetadata: MetricsTemplateShape,
  instrumentsWithMetadata: PropTypes.object.isRequired,
  availableMetrics: PropTypes.array.isRequired,
  flattenedMetrics: PropTypes.array.isRequired,
  betaInstrument: PropTypes.object.isRequired,
  customSelectedMetrics: PropTypes.arrayOf(PropTypes.object),
  selectedMetrics: PropTypes.arrayOf(PropTypes.object),
  setSelectedMetrics: PropTypes.func,
  forecasts: PropTypes.arrayOf(FORECAST),
}
